import {
  PolicyTextContent,
  PolicyTextContentProps,
} from '@/components/PolicyTextContent'

export type TranslatedPolicyTextProps = PolicyTextContentProps

export const TranslatedPolicyText = (props: TranslatedPolicyTextProps) => (
  <PolicyTextContent {...props} />
)
